import { render, staticRenderFns } from "./DataStoriesBlock.vue?vue&type=template&id=b3ff7654&scoped=true&"
import script from "./DataStoriesBlock.vue?vue&type=script&lang=js&"
export * from "./DataStoriesBlock.vue?vue&type=script&lang=js&"
import style0 from "./DataStoriesBlock.vue?vue&type=style&index=0&id=b3ff7654&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ff7654",
  null
  
)

export default component.exports